export default __webpack_public_path__ + "static/media/materials_document.dbb77173.png";